import { render, staticRenderFns } from "./SideBarComponent.vue?vue&type=template&id=1f962aec&scoped=true&"
import script from "./SideBarComponent.vue?vue&type=script&lang=js&"
export * from "./SideBarComponent.vue?vue&type=script&lang=js&"
import style0 from "./SideBarComponent.vue?vue&type=style&index=0&id=1f962aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f962aec",
  null
  
)

export default component.exports